import * as XLSX from "xlsx";
import { SeedOilData } from "../../models/oilProduction-model";

export const seedOilExport = (seedOilData: SeedOilData[]) => {
  if (!seedOilData || seedOilData.length === 0) {
    console.warn("⚠️ No records to export");
    return;
  }

  // Prepare data for Excel
  const formattedData = seedOilData.map((item) => ({
    "Seed Name": item.seedName,
    "No. of Batches": item.noOfBatches,
    "Oil in Ltr": item.oilInLtr,
    "Total%": item.percentage,
    "Seeds Crushed in Kgs": item.seedsCrushedInKgs,
    "Average Yield": item.averageYield,
    "Cakes Weight": item.cakesWeight,
  }));

  // Create worksheet
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);

  // Apply colors for Total and No Prod rows
  seedOilData.forEach((item, index) => {
    const rowNumber = index + 2; // +2 because Excel rows start at 1 and first row is header
    let fillColor = "";

    if (item.seedName === "Total") fillColor = "FFB3E5FC"; // Light Blue
    if (item.seedName === "No Prod") fillColor = "FFFFCDD2"; // Light Red

    if (fillColor) {
      // Apply background color to entire row
      Object.keys(formattedData[index]).forEach((colKey, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ c: colIndex, r: rowNumber - 1 });
        if (!ws[cellAddress]) ws[cellAddress] = { t: "s", v: "" }; // Ensure cell exists
        ws[cellAddress].s = {
          fill: { fgColor: { rgb: fillColor } },
          font: { bold: true },
        };
      });
    }
  });

  // Create workbook
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "SeedOilReport");

  // Export Excel
  XLSX.writeFile(wb, "SeedOilReport.xlsx");
};
